// Content for the Communications page final call-to-action.
export type Bi = { fr: string; en: string }

export const CTA_CITY_MAP = 'https://cdn.magicpatterns.com/patterns/generated-images/6834f29e-a36c-4571-bcbd-19814e18a93b.jpg'
export const CTA_SNOWPLOW = 'https://cdn.magicpatterns.com/patterns/generated-images/e45f1b3e-b364-4067-bd9e-9b74691f993d.jpg'

// Official logo files supplied by BCITI (1536 × 1024, white background).
export const LOGO_BCITI = { src: 'https://cdn.magicpatterns.com/uploads/ixfjnjTJMH3i6vSh3iS17H/Logo_BCITI_(20).png', x: 126, y: 386, w: 1306, h: 230 }
export const LOGO_ATNA = { src: 'https://cdn.magicpatterns.com/uploads/vctoBSiFXn6P3tKZbEmoez/Logo_ATNA_(18).png', x: 238, y: 338, w: 1112, h: 274 }

export const ctaCopy = {
  eyebrow: { fr: 'Passez à l’action', en: 'Take action' },
  line1: { fr: 'Chaque message compte.', en: 'Every message counts.' },
  line2: { fr: 'Assurez-vous qu’il arrive', en: 'Make sure it reaches' },
  line3: { fr: 'aux bonnes personnes.', en: 'the right people.' },
  body: {
    fr: 'Découvrez comment Communications ATNA transforme vos avis et notifications en communications ciblées, orchestrées et mesurables — du quotidien à l’urgence.',
    en: 'See how ATNA Communications turns your notices and notifications into targeted, orchestrated and measurable communications — from everyday updates to emergencies.',
  },
  primary: { fr: 'Voir Communications ATNA en action', en: 'See ATNA Communications in action' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
  keywords: {
    fr: ['Identité', 'Géociblage', 'Multicanal', 'Automatisation', 'Analytique', 'IA ATNA'],
    en: ['Identity', 'Geotargeting', 'Multichannel', 'Automation', 'Analytics', 'ATNA AI'],
  },
  tagline: { fr: 'Une intelligence de confiance. Conçue pour agir.', en: 'Trusted Intelligence. Built to Act.' },
}

export const networkCopy = {
  city: { fr: 'Votre ville', en: 'Your city' },
  notice: { title: { fr: 'Avis préparé', en: 'Notice prepared' }, body: { fr: 'Message clarifié et préparé par ATNA', en: 'Clear message prepared by ATNA' } },
  audience: {
    title: { fr: 'Public vérifié', en: 'Verified audience' },
    body: { fr: 'Citoyens ciblés selon le territoire, les intérêts et les préférences', en: 'Residents targeted by territory, interests and preferences' },
  },
  multichannel: {
    title: { fr: 'Diffusion multicanale', en: 'Multichannel delivery' },
    channels: [
      { key: 'voice', label: { fr: 'Voix', en: 'Voice' } },
      { key: 'sms', label: { fr: 'SMS', en: 'SMS' } },
      { key: 'push', label: { fr: 'Push', en: 'Push' } },
      { key: 'email', label: { fr: 'Courriel', en: 'Email' } },
    ],
  },
  reach: { value: { fr: '92 %', en: '92%' }, label: { fr: 'citoyens joints', en: 'residents reached' }, trend: { fr: '+18 %', en: '+18%' }, sub: { fr: 'par rapport à l’envoi précédent', en: 'vs previous send' } },
  reco: { title: { fr: 'ATNA recommande', en: 'ATNA recommends' }, body: { fr: 'Relancer les non joints du secteur ciblé.', en: 'Follow up with those not reached in the targeted sector.' } },
}

// Citizen node positions (% of the map area), around the centre at 50 / 44.
export const citizenNodes: [number, number][] = [
  [14, 8], [45, 7], [72, 5], [85, 16], [34, 20], [21, 34], [70, 30], [87, 42],
  [67, 50], [54, 57], [39, 57], [18, 58],
]

export const ctaOutcomes: { key: 'informed' | 'calls' | 'ops' | 'community'; title: Bi; body: Bi }[] = [
  { key: 'informed', title: { fr: 'Des citoyens mieux informés', en: 'Better-informed residents' }, body: { fr: 'Les bonnes informations, aux bonnes personnes.', en: 'The right information, to the right people.' } },
  { key: 'calls', title: { fr: 'Moins d’appels et de demandes', en: 'Fewer calls and requests' }, body: { fr: 'Des communications proactives et ciblées.', en: 'Proactive, targeted communications.' } },
  { key: 'ops', title: { fr: 'Des opérations plus efficaces', en: 'More efficient operations' }, body: { fr: 'Une meilleure coordination du quotidien aux urgences.', en: 'Better coordination, from everyday to emergencies.' } },
  { key: 'community', title: { fr: 'Une communauté plus engagée', en: 'A more engaged community' }, body: { fr: 'Des services municipaux plus accessibles et appréciés.', en: 'Municipal services that are more accessible and appreciated.' } },
]
